export const PRODUCT_CATEGORIES = ["All", "Vastu & Décor", "Gem Trees", "Bracelets", "Charms & More", "Wellness & Lifestyle"];

export const PRODUCTS = [
    {
        name: "Vastu Energy Symbols Set",
        price: "₹999",
        cat: "Vastu & Décor",
        img: "vastu-symbols",
        desc: "Premium Vastu symbols crafted to enhance positive energy flow and balance in your home or workspace.",
        features: ["Supports positive energy circulation", "Enhances focus & mental clarity"],
    },
    {
        name: "Pyrite Turtle",
        price: "₹550",
        cat: "Vastu & Décor",
        img: "pyrite-turtle",
        desc: "Vastu & Feng Shui inspired turtle — a symbol of stability, protection and perseverance.",
        features: ["Ideal for offices & study areas", "Place in North or Southeast"],
    },
    {
        name: "Pyrite Swastik",
        price: "₹555",
        cat: "Vastu & Décor",
        img: "pyrite-swastik",
        desc: "Raw Pyrite Swastik — strengthens Shani, attracts money and new opportunities.",
        features: ["Symbol of Shubh-Labh & protection", "Attracts success"],
    },
    {
        name: "Laxmi Pyramid 70MM",
        price: "₹110",
        cat: "Vastu & Décor",
        img: "laxmi-pyramid",
        desc: "A sacred pyramid inviting wealth and the blessings of Maa Laxmi into your space.",
        features: ["Wealth attraction", "Compact 70MM size"],
    },
    {
        name: "Seven Horse Metal Wall Décor",
        price: "₹3,999",
        cat: "Vastu & Décor",
        img: "seven-horse",
        desc: "Luxurious illuminated metal wall art inspired by traditional Vastu principles.",
        features: ["Modern LED effect", "Style, spirituality & décor in one"],
    },
    {
        name: "Crystal Bowl Gem Tree",
        price: "₹699",
        cat: "Gem Trees",
        img: "crystal-bowl-tree",
        desc: "Handcrafted gemstone tree for peaceful surroundings and elegant décor.",
        features: ["Ideal for home & office", "Beautiful decorative element"],
    },
    {
        name: "Seven Chakra Gem Tree",
        price: "₹799",
        cat: "Gem Trees",
        img: "chakra-tree",
        desc: "Seven-stone tree representing chakra balance and emotional well-being.",
        features: ["Balances all 7 chakras", "Enhances meditation spaces"],
    },
    {
        name: "Citrine Prosperity Tree",
        price: "₹699",
        cat: "Gem Trees",
        img: "citrine-tree",
        desc: "Citrine tree symbolizing abundance, success and business growth.",
        features: ["Popular for business intentions", "Elegant gold-pot décor"],
    },
    {
        name: "Wealth Attraction Tree",
        price: "₹899",
        cat: "Gem Trees",
        img: "wealth-tree",
        desc: "Feng Shui inspired gem tree — a symbol of prosperity and opportunities.",
        features: ["Premium gifting choice", "Attracts opportunities"],
    },
    {
        name: "Tree of Life — Chakra Balance",
        price: "₹999 – ₹1,200",
        cat: "Gem Trees",
        img: "tree-of-life",
        desc: "The classic Tree of Life for chakra balance, in three handcrafted sizes.",
        features: ["200 beads ₹999 · 300 beads ₹1,050", "500 beads ₹1,200"],
    },
    {
        name: "Crystal Bracelet — Series 1",
        price: "₹799",
        cat: "Bracelets",
        img: "bracelet-s1",
        desc: "Red Jasper, Pyrite, Tiger Eye, Opal Glass & Hematite — strength, wealth and focus.",
        features: ["Premium crystals", "Strength · Stability · Courage"],
    },
    {
        name: "Crystal Bracelet — Series 2",
        price: "₹799",
        cat: "Bracelets",
        img: "bracelet-s2",
        desc: "Rose Quartz, Golden & Silver Pyrite, Hematite, Garnet & Tiger Eye.",
        features: ["Love, healing & wealth", "Confidence & vitality"],
    },
    {
        name: "Crystal Bracelet — Series 3",
        price: "₹799",
        cat: "Bracelets",
        img: "bracelet-s3",
        desc: "Rose Quartz, Golden & Silver Pyrite, Hematite, Garnet & Tiger Eye.",
        features: ["Emotional balance", "Protection & courage"],
    },
    {
        name: "Crystal Bracelet — Series 4",
        price: "₹799",
        cat: "Bracelets",
        img: "bracelet-s4",
        desc: "Black Tourmaline, Pyrite, Citrine, Garnet & Red Jasper — the protection stack.",
        features: ["Dispels negativity", "Abundance, joy & positivity"],
    },
    {
        name: "Dhan Vriddhi Bracelet",
        price: "₹999",
        cat: "Bracelets",
        img: "dhan-vriddhi",
        desc: "A powerful wealth bracelet crafted to attract prosperity and growth.",
        features: ["Attracts wealth & prosperity", "Bold premium design"],
    },
    {
        name: "Dhanyog Money Magnet Bracelet",
        price: "₹799",
        cat: "Bracelets",
        img: "dhanyog",
        desc: "Pyrite, Citrine, Green Aventurine, Jade, Amethyst & Tiger's Eye in one magnet.",
        features: ["Luck, opportunity & steady income", "Confidence & willpower"],
    },
    {
        name: "Pregnancy & Fertility Bracelet",
        price: "₹799",
        cat: "Bracelets",
        img: "fertility",
        desc: "A gentle shield of positive energy for expecting and hopeful mothers.",
        features: ["Protection from evil eye", "Emotional balance & inner peace"],
    },
    {
        name: "Prosperity Hanging Keychain",
        price: "₹399",
        cat: "Charms & More",
        img: "hanging-keychain",
        desc: "A decorative prosperity charm symbolizing wealth, positivity and good fortune.",
        features: ["Popular gifting option", "Home, office or vehicle"],
    },
    {
        name: "Money Magnet Keychain",
        price: "₹350",
        cat: "Charms & More",
        img: "money-keychain",
        desc: "Premium beads and a musical charm designed to attract abundance.",
        features: ["Business growth intentions", "Elegant everyday piece"],
    },
    {
        name: "Prosperity Keychain",
        price: "₹350",
        cat: "Charms & More",
        img: "prosperity-keychain",
        desc: "Double Gourd, Chinese Coin, Lucky Knot & Black Bead — good luck every day.",
        features: ["Health, wealth & protection", "Positivity & balance"],
    },
    {
        name: "Chintamani Stone Pendant",
        price: "₹150",
        cat: "Charms & More",
        img: "pendant",
        desc: "An ancient-inspired pendant for wisdom, inner peace and personal growth.",
        features: ["Supports meditation", "Calmness & confidence"],
    },
    {
        name: "Phone Charms",
        price: "₹399",
        cat: "Charms & More",
        img: "phone-charm",
        desc: "Carry protection, luck and calm everywhere your phone goes.",
        features: ["Protects from negative energies", "Enhances positive energy flow"],
    },
    {
        name: "Success Symbol Wallet",
        price: "₹550",
        cat: "Wellness & Lifestyle",
        img: "wallet",
        desc: "A premium wallet with sacred success and prosperity symbols.",
        features: ["Stylish & durable", "A meaningful daily companion"],
    },
    {
        name: "Natural Crystal Eye Mask",
        price: "₹1,800",
        cat: "Wellness & Lifestyle",
        img: "eye-mask",
        desc: "A luxury crystal eye mask for a deeply relaxing, refreshing experience.",
        features: ["Cooling crystal therapy", "Perfect for self-care rituals"],
    },
    {
        name: "Numerology Personalized Set",
        price: "₹299",
        cat: "Wellness & Lifestyle",
        img: "numerology-personal",
        desc: "Personalized by your date of birth — made to unlock your true path.",
        features: ["Customized to your DOB", "Unique Ink of Destiny special"],
    },
];
